import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';

const mockProps = {
  onGetAccessToken: () => 'eyJhbGciOiJSUzI1NiIsImtpZCI6InFObGhkUEtyWUZhZlJoTi1sRnNDekM5djdQX19lbjNWZndkV2VLVElkOEUiLCJ0eXAiOiJKV1QifQ.eyJhdWQiOiJlYjhiNWJlOS0wMGVlLTQwOGMtODVkOC02ZjM3YzJiY2VlNjEiLCJpc3MiOiJodHRwczovL3NpZ25pbm5vbnByb2QubG9yZWhlYWx0aGNhcmUuY29tLzJhY2QzOTliLWRmZWItNDFlNS1hNGY5LThkMTU4ZGI1NjRkYy92Mi4wLyIsImV4cCI6MTc0Nzg0OTc2NCwibmJmIjoxNzQ3NzYzMzY0LCJ0ZnAiOiJCMkNfMUFfU1VTSV9DT01NVU5JVFlfVEVTVCIsInNjcCI6IkNvbW11bml0eS5BZG1pbiBDb21tdW5pdHkuQVBJQWNjZXNzIFVzZXIuUmVhZCIsImF6cGFjciI6IjEiLCJzdWIiOiI3ODFhZTgzOS02YmU5LTQ4NjktOWQ2MC04ZDM3ZTU3ZmFjNmYiLCJvaWQiOiI3ODFhZTgzOS02YmU5LTQ4NjktOWQ2MC04ZDM3ZTU3ZmFjNmYiLCJ0aWQiOiIyYWNkMzk5Yi1kZmViLTQxZTUtYTRmOS04ZDE1OGRiNTY0ZGMiLCJ2ZXIiOiIyLjAiLCJhenAiOiJlNzM2MmFiYS1kODI2LTQwNmYtODRmOS1mYjY0MmFhY2RkNGMiLCJpYXQiOjE3NDc3NjMzNjR9.rtAVzoFGXis79TiirQbyr-U_4LcIz8KGteKHqRdDpDqYMMbBgKFxAG3nq7n9FTDEoLAjmKpzufFFOtN39ayUNa77p_AwPfIkQ-xCKd8BKdbwp5YUmqtM1LcKouzafOtt-CQI2jVKh_EhTNWD2Im5ldUlEuYh8HTrkbB4EE9PV64Ubc-qU0qMwauXqO_lv4XR2ku0pxaxsjpFBktGA22YxpwGol2ZhmRkzVjTT2Pya62oO8o0eIiIwFsm6dItAkSoasc_WHEU_z7Iwb297xwES5AUuL2ar3pYdHbd0q8N9kQ8_jbMJxhUp0ZVHobXsv1Wp7iC8A0aNQI-taNcEwgh0A',
  hostAuthResult: {},
  externalRefUserId: '44016',
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App {...mockProps} />
    </Provider>
  </React.StrictMode>
);
